/**
 * Release notes PDFs shipped locally with the app (assets/release-notes/<version>.pdf), newest first.
 * Used both by the Assistance page and the "what's new" popup shown on login.
 * Add an entry here for every new release, and drop the matching PDF in src/assets/release-notes/.
 */
export const LOCAL_RELEASE_NOTES: Record<string, string> = {
  '6.2.0': 'assets/release-notes/6.2.0.pdf',
  '6.1.1': 'assets/release-notes/6.1.1.pdf',
  '6.1.0': 'assets/release-notes/6.1.0.pdf',
};

/**
 * The most recent version, used to decide whether the "what's new" popup should be shown.
 */
export const LATEST_LOCAL_VERSION: string = Object.keys(LOCAL_RELEASE_NOTES)[0];
